export const splitTabBarItems = <T>(
  items: T[],
): {
  primary: T[];
  overflow: T[];
} => {
  if (items.length <= 5) {
    return { primary: items, overflow: [] };
  }

  return {
    primary: items.slice(0, 4),
    overflow: items.slice(4),
  };
};
